<template>
  <v-list-item class="px-0">
    <v-list-item-avatar class="mr-0">
      <h5 class="mb-0">{{ index + 1 }}.</h5>
    </v-list-item-avatar>
    <v-list-item-content class="flex-shrink-0">
      <v-list-item-title>
        {{ ticket.TicketBlock?.TicketGroup?.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ ticket.TicketBlock?.name }}
        <v-chip
          v-if="ticket.Payment?.paymentType === 'COURTESY'"
          color="info--text"
          class="ml-2"
          x-small
          text
          label
        >
          Cortesia
        </v-chip>
      </v-list-item-subtitle>
    </v-list-item-content>
    <div
      class="d-flex flex-column flex-grow-0 justify-end text-right"
      style="max-width: 50%"
    >
      <span v-if="isPersonal" class="text-caption lh-1">
        Ingresso pessoal
      </span>
      <span
        v-else-if="filesCache[ticket.id]?.shareName"
        class="text-caption lh-1"
      >
        Compartilhado com {{ filesCache[ticket.id]?.shareName }}
      </span>
      <span
        v-else-if="ticket.TicketShare?.length > 0"
        class="text-caption lh-1 error--text"
      >
        Já compartilhado com {{ getShareName(ticket) }}
      </span>
      <div class="d-flex justify-end gap-2">
        <ticket-exporter-action-btn
          v-if="canShare"
          label="Compartilhar PDF"
          icon="mdi-share"
          small
          :disabled="disable"
          :loading="loadingShare"
          :checked="shared"
          @click="$emit('share')"
        />
        <ticket-exporter-action-btn
          label="Baixar PDF"
          icon="mdi-download"
          small
          :disabled="disable"
          :loading="loadingExport"
          :checked="downloaded"
          @click="$emit('download')"
        />
      </div>
    </div>
  </v-list-item>
</template>
<script>
import TicketExporterActionBtn from "./TicketExporterActionBtn.vue";
export default {
  name: "TicketExporterListItem",
  components: {
    TicketExporterActionBtn,
  },
  data() {
    return {
      canShare: window.navigator.share,
    };
  },
  computed: {
    isPersonal() {
      return (
        this.ticket.Payment?.paymentType === "COURTESY" ||
        !this.ticket.TicketBlock.allowTransfer
      );
    },
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    loadingShare: {
      type: Boolean,
      default: false,
    },
    loadingExport: {
      type: Boolean,
      default: false,
    },
    shared: {
      type: Boolean,
      default: false,
    },
    downloaded: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    filesCache: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getShareName(ticket) {
      const names = ticket.TicketShare.reduce((acc, share) => {
        acc.set(share.name.toLowerCase(), share.name);
        return acc;
      }, new Map());
      if (names.size === 1) return names.values().next().value;
      return `${names.size} pessoas`;
    },
  },
};
</script>
